export default __webpack_public_path__ + "static/media/28_thumbnail.5ff2a675.JPG";